<script setup lang="ts">
import { Synonym } from "~/classes/models/thesaurus/synonym.model";
import {
  CompleteWord,
  Definition,
} from "~/classes/models/thesaurus/thesaurus-word.model";

const documentId = inject("documentId") as any;
const thesaurusStore = useDocumentThesaurusStore(documentId);
const { currentPage } = storeToRefs(thesaurusStore);

const definitionSynonyms = computed(() => {
  return (definition: Definition) => {
    if (currentPage.value.data == undefined) return [];

    const completeWord = currentPage.value.data as CompleteWord;

    return completeWord.synonyms.filter(
      (synonym: Synonym) => synonym.parentDefinitionId == definition.id
    );
  };
});
</script>

<template>
  <div
    v-if="currentPage.type == ThesaurusPageType.word"
    :key="`${currentPage.isLoading}`"
    v-auto-animate
  >
    <div
      v-if="
        currentPage.data != undefined &&
        currentPage.type == ThesaurusPageType.word &&
        currentPage.isLoading != true
      "
      class="flex flex-col gap-6"
    >
      <div
        v-for="definition in currentPage.data.word.definitions"
        :key="definition.id"
      >
        <DocumentEditorReviewPanelThesaurusWordList>
          <template #label>
            {{ definition.definition }}
          </template>
          <template #words>
            <DocumentEditorReviewPanelThesaurusTappableWord
              v-for="synonym in definitionSynonyms(definition)"
              :key="synonym.childWord"
              :word="synonym.childWord"
              @click="
                thesaurusStore.addPage({
                  type: ThesaurusPageType.word,
                  key: synonym.childWord,
                  data: undefined,
                  isLoading: ref(true),
                  label: synonym.childWord,
                })
              "
            >
              {{ synonym.childWord }}
            </DocumentEditorReviewPanelThesaurusTappableWord>
          </template>
        </DocumentEditorReviewPanelThesaurusWordList>
      </div>
    </div>
    <div v-if="currentPage.isLoading == true" class="flex flex-col gap-6">
      <DocumentEditorReviewPanelThesaurusWordList v-for="i in 3" :key="i" />
    </div>
  </div>
</template>

<style scoped></style>
